/* Bannière cookies native Shopify : textes GeoRide par langue (fichiers de langue du thème, clé general.cookies).
   17/09/2026 : Shopify ne permet pas de modifier le texte français par défaut ni par l'API, et Translate & Adapt ne propose pas
   la langue par défaut. On réécrit donc le texte affiché après l'injection de la bannière, sans toucher au mécanisme de consentement
   (les boutons restent ceux de Shopify, seul leur libellé change). Si une clé manque, le texte Shopify reste. */
(function () {
  var conf = document.getElementById('gr-cookie-texts');
  if (!conf) return;
  var t;
  try { t = JSON.parse(conf.textContent); } catch (e) { return; }
  /* Le filtre Liquid `t` échappe les apostrophes en &#39; : on décode les entités avant affichage. */
  function decoder(v) { var ta = document.createElement('textarea'); ta.innerHTML = v; return ta.value; }
  Object.keys(t).forEach(function (k) { if (typeof t[k] === 'string') t[k] = decoder(t[k]); });
  function ok(v) { return typeof v === 'string' && v && v.indexOf('translation missing') === -1; }
  function appliquer(banner) {
    if (!banner || banner.dataset.grTexte === '1') return;
    var h2 = banner.querySelector('h2');
    var p = banner.querySelector('.shopify-pc__banner__body p');
    var lien = p ? p.querySelector('a') : null;
    if (h2 && ok(t.title)) h2.textContent = t.title;
    if (p && ok(t.body)) {
      if (lien && ok(t.policy_link)) lien.textContent = t.policy_link;
      var txt = document.createTextNode(t.body + ' ');
      while (p.firstChild) p.removeChild(p.firstChild);
      p.appendChild(txt);
      if (lien) p.appendChild(lien);
    }
    var b;
    if ((b = banner.querySelector('.shopify-pc__banner__btn-accept')) && ok(t.accept)) b.textContent = t.accept;
    if ((b = banner.querySelector('.shopify-pc__banner__btn-decline')) && ok(t.decline)) b.textContent = t.decline;
    if ((b = banner.querySelector('.shopify-pc__banner__btn-manage-prefs')) && ok(t.manage)) {
      var span = b.querySelector('span');
      (span || b).textContent = t.manage;
    }
    banner.dataset.grTexte = '1';
  }
  appliquer(document.getElementById('shopify-pc__banner'));
  var obs = new MutationObserver(function () {
    var b = document.getElementById('shopify-pc__banner');
    if (b) appliquer(b);
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
